import styled from "styled-components";

export const Wrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  bottom: 120px;
  right: 15px;
  height: 60%;
  border: 1px solid ${(p) => p.theme.colors.border};
  border-radius: 10px;
  padding-bottom: 20px;
  background-color: rgba(255, 255, 255, 0.78);
  z-index: 1000000;
  background: white;
  box-shadow: rgb(0 0 0 / 10%) 0px 1px 6px, rgb(0 0 0 / 20%) 0px 2px 24px;
`;

export const Heading = styled.div`
  height: 60px;
  background: rgb(66, 91, 118);
  color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  font-weight: bold;
  font-size: 1.2rem;
`;

export const Notes = styled.div`
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 400px;
`;

export const ScrollWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  overflow: auto;
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 6px;
`;

export const CommentIcon = styled.div`
  background: rgb(66, 91, 118);
  color: white;
  height: 80px;
  width: 80px;
  position: fixed;
  bottom: 20px;
  right: 15px;
  font-size: 40px;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: rgb(0 0 0 / 10%) 0px 1px 6px, rgb(0 0 0 / 20%) 0px 2px 24px;
`;
